import {loginEpic, renewAuthTokenEpic, reauthenticateEpic} from 'educat-common-web';
import {combineEpics} from 'redux-observable';


export const rootEpic = combineEpics(
    loginEpic,
    renewAuthTokenEpic,
    reauthenticateEpic
);
